import React from 'react';
import ScrollAnimation from "react-animate-on-scroll";

const callToActionData = {
    title: "Ready to start creating a standard website?",
    subtitle: "Full-spectrum digital solutions, future-ready partnership.",
    btnText: "Purchase Doob",
}

const CalltoActionOne = () => {
    return (
        <div className="rn-callto-action clltoaction-style-default bg_image bg_image_fixed" style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/bg/bg-image-1.jpg)` }} data-black-overlay="7">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="inner">
                            <div className="content text-center">
                                <ScrollAnimation
                                    animateIn="fadeInUp"
                                    animateOut="fadeInOut"
                                    animateOnce={true}>
                                    <h2 className="title">{callToActionData.title}</h2>
                                </ScrollAnimation>

                                <ScrollAnimation
                                    animateIn="fadeInUp"
                                    animateOut="fadeInOut"
                                    animateOnce={true}>
                                    <h6 className="subtitle">{callToActionData.subtitle}</h6>
                                </ScrollAnimation>

                                <ScrollAnimation
                                    animateIn="fadeInUp"
                                    animateOut="fadeInOut"
                                    animateOnce={true}>
                                    <div className="call-to-btn">
                                        <a className="btn-default" href="#" aria-label="Purchase Doob - Ready to start creating a standard website">{callToActionData.btnText}</a>
                                    </div>
                                </ScrollAnimation>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default CalltoActionOne;